// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".audio-component[data-v-044dc77d] {\n  max-width: 250px;\n}\n", ""]);
// Exports
module.exports = exports;
